/* NCMPRBL — Elevate Link motion layer
   Quiet luxury: reveal masks, scrub-reading, a restrained hero parallax,
   one editorial drift band, marquee, and a persistent collection dock. */
(function () {
  'use strict';

  /* ---- section lifecycle plumbing (added 2026-08-12) ---------------------
     Shopify's theme editor destroys and re-renders a section's DOM on every
     edit without reloading the page, and it never re-runs a deferred script.
     Without this, one edit left the page inert and leaked a window listener
     per edit. init() holds all state, destroy() releases it, and GEN
     invalidates any rAF callback still queued from a previous generation. */
  var CLEANUP = [], GEN = 0;
  function on(target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    CLEANUP.push(function () { target.removeEventListener(type, fn, opts); });
  }
  function tracked(observer) {
    CLEANUP.push(function () { observer.disconnect(); });
    return observer;
  }
  function destroy() {
    GEN++;
    for (var i = 0; i < CLEANUP.length; i++) { try { CLEANUP[i](); } catch (e) {} }
    CLEANUP.length = 0;
  }

  function init() {
    var MY_GEN = ++GEN;
    function alive() { return MY_GEN === GEN; }

    /* ---------- live pricing (injected) ----------------------------------------
       Prices come from the #lp-prices JSON block, which the Liquid section renders
       directly from the product records. This file holds no authoritative price;
       the strings in FRAMES are a fallback for when the block is absent. */
    var LP_PRICES = (function () {
      try { return JSON.parse(document.getElementById('lp-prices').textContent); }
      catch (e) { return {}; }
    })();
    function lpRec(url) {
      var m = /\/products\/([^\/?#]+)/.exec(url || '');
      return (m && LP_PRICES[m[1]]) || null;
    }
    function lpPrice(url, fallback) {
      var r = lpRec(url);
      if (!r || !r.money) return fallback || '';
      return /USD/.test(fallback || '') ? r.money + ' USD' : r.money;
    }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var heroImg = document.getElementById('heroImg');
    var dock = document.getElementById('dock');
    var reveals = [].slice.call(document.querySelectorAll('.rv, .clip, .lines'));
    var drifts = [].slice.call(document.querySelectorAll('[data-drift]'));
    var scrub = document.querySelector('[data-scrub]');
    var scrubWords = [];
    var ticking = false;

    if (scrub) {
      var words = scrub.textContent.trim().split(/\s+/);
      scrub.textContent = '';
      words.forEach(function (word, index) {
        var unit = document.createElement('b');
        unit.textContent = word;
        scrub.appendChild(unit);
        if (index < words.length - 1) scrub.appendChild(document.createTextNode(' '));
        scrubWords.push(unit);
      });
    }

    function runReveals() {
      var viewport = window.innerHeight;
      for (var i = reveals.length - 1; i >= 0; i--) {
        var rect = reveals[i].getBoundingClientRect();
        if (rect.top < viewport * 0.9 && rect.bottom > 0) {
          reveals[i].classList.add('in');
          reveals.splice(i, 1);
        }
      }
    }

    function drawFrame() {
      if (!alive()) return;
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      var viewport = window.innerHeight;
      runReveals();

      if (!reduce && heroImg && y < viewport * 1.15) {
        var progress = Math.min(1, y / viewport);
        heroImg.style.transform = 'scale(' + (1.05 - progress * 0.035) + ') translateY(' + (progress * 28) + 'px)';
      }

      if (!reduce) {
        drifts.forEach(function (row) {
          var rect = row.getBoundingClientRect();
          if (rect.bottom < -160 || rect.top > viewport + 160) return;
          var progress = (viewport - rect.top) / (viewport + rect.height);
          var span = row.scrollWidth / 2;
          var shift = (progress - 0.5) * span * 0.26 * Number(row.dataset.drift);
          row.style.transform = 'translateX(' + (-span * 0.24 - shift) + 'px)';
        });
        if (scrubWords.length) {
          var scrubRect = scrub.getBoundingClientRect();
          var fill = (viewport * 0.86 - scrubRect.top) / (scrubRect.height + viewport * 0.24);
          fill = Math.max(0, Math.min(1, fill));
          var lit = Math.round(fill * scrubWords.length);
          scrubWords.forEach(function (word, index) { word.classList.toggle('lit', index < lit); });
        }
      } else {
        scrubWords.forEach(function (word) { word.classList.add('lit'); });
      }

      if (dock) {
        var collection = document.getElementById('collection');
        var close = document.querySelector('.close');
        var show = collection && y + viewport > collection.offsetTop + 190 && (!close || y + viewport < close.offsetTop + 120);
        dock.classList.toggle('on', Boolean(show));
      }
    }

    function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(drawFrame); } }
    on(window, 'scroll', schedule, { passive: true });
    on(window, 'resize', schedule, { passive: true });
    drawFrame();

    var details = [].slice.call(document.querySelectorAll('.faq details'));
    details.forEach(function (item) {
      on(item, 'toggle', function () {
        if (item.open) details.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  }

  function boot() {
    destroy();
    if (document.querySelector('.elevate-lp')) init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t && t.querySelector && (t.querySelector('.elevate-lp') || t.matches && t.matches('.elevate-lp'))) boot();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var t = e.target;
    if (t && t.querySelector && (t.querySelector('.elevate-lp') || t.matches && t.matches('.elevate-lp'))) destroy();
  });
})();
